import { CONTACT_TYPE_OPTIONS, FIELD_PATHS } from '@funnels/constants';
import { RelatedPartyEntityIndex } from '@funnels/types';

import { DropdownField } from '../../../Fields';

interface ContactTypeProps extends RelatedPartyEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const ContactType = ({ relatedPartyIndex, isOptional, isDisabled }: ContactTypeProps) => (
  <DropdownField
    label="Contact type"
    name={FIELD_PATHS.RELATED_PARTY_TYPE(relatedPartyIndex)}
    options={CONTACT_TYPE_OPTIONS}
    isOptional={isOptional}
    isDisabled={isDisabled}
  />
);
